import { render, staticRenderFns } from "./UserManagementShow.vue?vue&type=template&id=b9fc7e36&"
import script from "./UserManagementShow.vue?vue&type=script&lang=js&"
export * from "./UserManagementShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports